
import { isArray, pageTo, getGlobalStorage, ajax, isFunction, getSafeRandom, toast } from '@platform/api';
import { promptBox } from '../PromptBox';
import SignIn from '../ButtonApp/SignIn';
const PID = '__root__';
let parentPk = null;

/* 根据key获取子树 */
export function getItem(treeData, key) {
    if (!key) {
        return treeData;
    }
    let length = treeData.length;
    for (let i = 0; i < length; i++) {
        let item = treeData[i];
        if (item.key == key || item.refpk == key) {
            return item;
        } else if (Array.isArray(item.children)) {
            let res = getItem(item.children, key);
            if (res) {
                return res;
            }
        }
    }
}

/** 将树拉平为数据 */
export function treeToList(treeData, list = [], pid = PID) {
    if (Array.isArray(treeData)) {
        treeData.forEach(e => {
            // 获取除 children 外的其他属性，并且放进list数组
            let { children, ...others } = e;
            others.pid = others.pid ? others.pid : pid;
            list.push({ ...others });
            if (Array.isArray(e.children)) {
                treeToList(e.children, list, e.refpk);
            }
        });
        // 返回list集合
        return list;
    } else {
        return false;
    }
}

// /** 将树拉平为数据  广度优先*/
// export function treeToList(tree, nodeKey = 'refpk', parentKey = 'pid', childrenKey = 'children') {
//     const tempList = tree.slice(0);
//     const res = [];
//     for (let node of tempList) {
//         const { [childrenKey]: children, ...rest } = node;
//         res.push({
//             ...rest,
//             [parentKey]: node[parentKey] || null,
//         });
//         if (node[childrenKey] && node[childrenKey].length) {
//             tempList.push(
//                 ...node[childrenKey].map(item => {
//                     item[parentKey] = node[nodeKey];
//                     return item;
//                 }),
//             );
//         }
//     }
//     return res;
// }

/**获取所有主键*/
export function getAllTreeKeys(treeData, list = []) {
    if (Array.isArray(treeData)) {
        treeData.forEach(e => {
            // 获取除 children 外的其他属性，并且放进list数组
            let { refpk, key, id } = e;
            let pk = refpk || key || id;
            list.push(pk);
            if (Array.isArray(e.children)) {
                getAllTreeKeys(e.children, list);
            }
        });
        // 返回list集合
        return list;
    } else {
        return false;
    }
}

/** 添加isleaf标识 ？？？？？*/
/// 外部未引用
export function addIsLeaf(data, { resetIcon } = {}) {
    (data || []).forEach(item => {
        // 不应该一股脑
        let ib = item.iconBox || {};
        // 需求要求的是取  默认true
        item.iconBox = resetIcon === false ? ib : {
            addIcon: true,
            delIcon: true,
            editIcon: true,
            ...ib,
        };
        if (!item.hasOwnProperty('isleaf')) {
            if (Array.isArray(item.children) && item.children.length) {
                item.isleaf = false;
                addIsLeaf(item.children, { resetIcon });
            } else {
                item.isleaf = true;
            }
        }else{
            if(Array.isArray(item.children) && item.children.length){
                addIsLeaf(item.children, { resetIcon });
            }
        }
    });
}

export function addNodeFun(treeData, child, isBefore) {
    if (!child.pid) {
        treeData.push(child);
        return;
    }
    const loop = data => {
        data.forEach(item => {
            if (item.refpk === child.pid) {
                if (Array.isArray(item.children)) {
                    if (isBefore) {
                        item.children.unshift(child);
                    } else {
                        item.children.push(child);
                    }
                } else {
                    item.children = [child];
                }
                item.isleaf = false;
                item.isLeaf = false;
                return true;
            } else if (Array.isArray(item.children)) {
                let res = loop(item.children);
                if (res) {
                    return false;
                }
            }
        });
    };
    loop(treeData);
}

export function addNodeChildrenFun(treeData, child, pid) {
    const loop = data => {
        data.forEach(item => {
            if (item.refpk === pid) {
                item.children = child;
                item.isleaf = false;
                item.isLeaf = false;
                return true;
            } else if (Array.isArray(item.children)) {
                let res = loop(item.children);
                if (res) {
                    return false;
                }
            }
        });
    };
    loop(treeData);
}

//外部未引用
//  获取符合查询关键字的节点的父节点
export function getParentKey(key, tree) {
    let parentKey;
    for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        if (node.children) {
            if (node.children.some(item => (item.key || item.id) === key)) {
                parentKey = node.key || node.id;
            } else if (getParentKey(key, node.children)) {
                parentKey = getParentKey(key, node.children);
            }
        }
    }

    return parentKey;
}

//外部未引用
//  获取符合查询关键字的节点的父节点
export function getAllParentKey(key, tree, parentKeys = []) {
    let parentKey;
    while (parentKey = getParentKey(key, tree)) {
        parentKeys.push(parentKey);
        key = parentKey;
    }
    return parentKeys;
}

export function moveNodeEve(tree, node, targetpk) {
    let i = tree.length;
    while (i--) {
        let data = tree[i];
        if (data.refpk === targetpk) {
            if (Array.isArray(data.children)) {
                data.children.push(node);
            } else {
                data.children = [node];
            }
            return true;
        } else {
            if (Array.isArray(data.children)) {
                let res = moveNodeEve(data.children, node, targetpk);
                if (res) {
                    return false;
                }
            }
        }
    }
}

export function setLeafEdit(data, status) {
    data.forEach(item => {
        if (item.isleaf) {
            item.iconBox = {
                addIcon: status,
                delIcon: status,
                editIcon: status,
            };
        } else if (Array.isArray(item.children)) {
            setLeafEdit(item.children, status);
        }
    });
}

export function hideIconEve(tree, key, iconObj) {
    let i = tree.length;
    while (i--) {
        let data = tree[i];
        if (data.key === key || data.refpk === key) {
            data.iconBox = Object.assign(data.iconBox || {}, iconObj);
            return true;
        } else {
            if (Array.isArray(data.children)) {
                let res = hideIconEve(data.children, key, iconObj);
                if (res) {
                    return false;
                }
            }
        }
    }
}

export function addBrotherFun(treeData, child, preNodePk) {
    if (!child.pid) {
        treeData.push(child);
        return;
    }
    const loop = data => {
        let len = data.length;
        for (let i = 0; i < len; i++) {
            let item = data[i];
            if ((item.pid === child.pid && !preNodePk) || (preNodePk && item.refpk === preNodePk && item.pid === child.pid)) {
                if (!preNodePk) {
                    data.push(child);
                } else {
                    data.splice(i, 0, child);
                }
                return true;
            } else if (Array.isArray(item.children)) {
                let res = loop(item.children);
                if (res) {
                    return false;
                }
            }
        }
    };
    loop(treeData);
}

export function editNodeFun(treeData, child, callback = () => {}) {
    if (!child.refpk) {
        console.error('树，编辑节点方法，传参错误，没找到refpk');
        return false;
    }
    let list = treeToList(treeData),
        old = list.find(e => e.refpk === child.refpk);
    old && Object.assign(old, child);
    old && callback(child);
    return createTreeData(list);
}

export function delNode(tree, key, parentNode = {}) {
    if (!tree) {return;}
    let i = tree.length;
    while (i--) {
        let data = tree[i];
        if (data.refpk === key) {
            parentNode.parentPk = data.pid || data.parentcode;
            tree.splice(i, 1);
            return true;
        } else {
            if (Array.isArray(data.children)) {
                let res = delNode(data.children, key, parentNode);
                if (res) {
                    return false;
                }
            }
        }
    }
}

export function addIconBox(data) {
    if (data && data instanceof Array && data.length > 0) {
        data.forEach(item => {
            let ib = item.iconBox || {};
            item.iconBox = {
                addIcon: true,
                delIcon: true,
                editIcon: true,
                ...ib,
            };
            if (Array.isArray(item.children)) {
                addIconBox(item.children);
            }
        });
    }
}

export function setNodeDisableEve(treeData, disable, pk) {
    let findYou = false;
    let len = treeData.length;

    if (Array.isArray(pk)) {
        pk.forEach(item => setNodeDisableEve(treeData, disable, item));
    } else {
        for (let i = 0; i < len; i++) {
            let item = treeData[i];
            if (pk) {
                if (item.refpk === pk) {
                    treeData[i].disabled = disable;
                    findYou = true;
                    return;
                }

            } else {
                treeData[i].disabled = disable;
            }
            if (Array.isArray(item.children)) {
                setNodeDisableEve(item.children, disable, pk);
                if (findYou) {
                    return false;
                }
            }
        }
    }

}

export function checkHasChildren(tree, pk) {
    let i = tree.length;
    while (i--) {
        let data = tree[i];
        if (data.refpk === pk) {
            if (Array.isArray(data.children) && data.children.length === 0) {
                delete data.children;
                data.isleaf = true;
            }
            return true;
        } else {
            if (Array.isArray(data.children)) {
                let res = checkHasChildren(data.children, pk);
                if (res) {
                    return false;
                }
            }
        }
    }
}

export function createTreeData(data, { resetIcon } = {}) {
    if (!isArray(data)) {
        console.warn('createTreeData方法，参数应该为数组');
        return false;
    }
    if (!data.length) {
        return [];
    }

    // 创建Map集合
    let group = new Map();
    data.forEach(e => {
        // 如果没有pid的节点标记为 __root__ 祖节点
        e.pid = e.pid || PID;
        // 处理查询区树没有key的问题
        e.key || (e.key = e.refpk);

        // 把相同pid的节点放在一起 结构：以pid为键 以相同pid节点组成的数组为值
        group.get(e.pid) ? group.get(e.pid).push(e) : group.set(e.pid, [e]);
    });

    function makeDOM(pid) {
        // 如果map 里面 pid 有值，就给每个节点追加children属性
        if (group.get(pid)) {
            // 返回的是map生成的数组,数组成员是e
            return group.get(pid).map(e => {
                // 处理查询区树没有key的问题
                e.key || (e.key = e.refpk);
                e.children = makeDOM(e.refpk);
                return e;
            });
        } else {
            return null;
        }
    }
    let newData = makeDOM(PID);

    addIsLeaf(newData, { resetIcon });
    return newData;
}

/**
 * 根据父级pk获取子节点pk
 * @param {*} parentPk 
 * @param {*} includeParentPk 
 */
export function getChildrenPk(treeData, parentPk, includeParentPk = false) {
    let allPks = includeParentPk ? (Array.isArray(parentPk) ? parentPk : [parentPk]) : [];
    const loopData = data => {
        for (let i = 0; i < data.length; i++) {
            let { refpk, key, children } = data[i];
            let pk = refpk || key;
            allPks.push(pk);
            if (Array.isArray(children)) {
                loopData(children);
            }
        }
    };
    const parentNode = getItem(treeData, parentPk) || {};
    loopData(parentNode.children || []);
    return allPks;
}

//  获取所有节点的key,返回数组
export function getAllNodeKeys(data){
    let allKeys = [];
    let getAllNodeKey = data => {
        data.forEach(item => {
            if (Array.isArray(item.children)) {
                allKeys.push(item.key);
                getAllNodeKey(item.children);
            }
        });
    };
    getAllNodeKey(data);
    return allKeys;
}

// 所有图标按钮点击事件，为了统一处理关键功能
export async function iconClick({ item = {}, _this, onClick, langJson, currentKey }){
    let { billinfo = {} } = _this;
    let scope = {};
    if (item.rowDisabled === true) {return;}
    if (item.iskeyfunc) {
        const appcode = billinfo.appcode || pageTo.getAppCode();
        const { userCode } = JSON.parse(getGlobalStorage('localStorage', 'STOREFORINFODATA')) || {};
        const checkMode = await new Promise(resolve => {
            ajax({
                url: '/nccloud/baseapp/ncckeyfunc/authentype.do',
                loading: false,
                data: {
                    // 应用编码
                    appcode,
                    // 按钮编码,就是key
                    appbtncode: currentKey,
                },
                success: res => {
                    const { data } = res;
                    switch (data) {
                        case '0': /** 用户密码校验 */
                            promptBox({
                                color: 'info',
                                hotKeyboard: true,
                                // 关键功能验证
                                title: langJson['page-button-0014'],
                                content: <SignIn ref={self => scope = self} lang={langJson} resolve={resolve} />,
                                noFooter: false,
                                noCancelBtn: false,
                                // 确定
                                beSureBtnName: langJson['page-button-0008'],
                                // 取消
                                cancelBtnName: langJson['page-button-0009'],
                                beSureBtnClick: () => {
                                    // 进行登录校验
                                    const { handleSignIn, state: { inputValue } } = scope;
                                    handleSignIn(userCode, inputValue);
                                },
                                cancelBtnClick: () => {
                                    console.log('Cancel');
                                },
                            });
                            return;
                        case '1': /**强制ca校验 **/
                            if (isFunction(window.superSign)) {
                                const { status, msg } = window.superSign(String(getSafeRandom() * 1000 + getSafeRandom()), userCode, true, true);
                                switch (status) {
                                    // 返回0表示通过
                                    case 0:
                                        resolve(true);
                                        break;
                                    // 返回1 表示不通过
                                    case 1:
                                        toast({
                                            content: '',
                                            color: 'danger',
                                            groupOperation: true,
                                            isNode: true,
                                            // '展开', '收起', '关闭'
                                            TextArr: [langJson['page-button-0010'], langJson['page-button-0011'], langJson['page-button-0012']],
                                            // ca检验不成功的提示信息
                                            groupOperationMsg: [msg],
                                        });
                                        resolve(false);
                                        break;
                                }
                            }
                            return;
                        case '2'://不进行校验
                            resolve(true);
                            return;
                    }
                },
                error: res => {
                    console.log('后端报错', res);
                },
            });
        });
        if (!checkMode) {
            /**
             * 用户没有按钮权限的情况
             * 终止代码执行
             */
            return;
        }
    }
    onClick();
}

export function bfs(treeData, callback) {
    if (!treeData || !treeData.length) {
        return [];
    }

    const queue = new Deque();
    treeData.forEach(node => queue.addBack(node));

    while (!queue.isEmpty()) {
        const currentNode = queue.removeFront();

        let res = callback(currentNode);
        if (res) {
            return;
        }
        if (
            Array.isArray(currentNode.children) &&
        currentNode.children.length > 0
        ) {
            currentNode.children.forEach(child => queue.addBack(child));
        }
    }
}

export function dfs(treeData, callback) {
    // 类型检查
    if (!Array.isArray(treeData) || typeof callback !== "function") {
        return [];
    }

    const traverse = node => {
        try {
            let res = callback(node);
            if (res) {
                return true;
            }
        } catch (error) {
            console.error("Callback execution failed:", error);
            return false; // 继续遍历其他节点
        }

        // 检查 children 是否为非空数组
        if (Array.isArray(node.children) && node.children.length > 0) {
            for (const child of node.children) {
                if (traverse(child)) {
                    return true;
                }
            }
        }
        return false;
    };

    for (const node of treeData) {
        if (traverse(node)) {
            return;
        }
    }
}
//实现一个高性能的Deque
class Deque {
    constructor() {
        this.items = {};
        this.count = 0;
        this.lowestCount = 0;
    }

    addFront(element) {
        if (this.isEmpty()) {
            this.addBack(element);
        } else if (this.lowestCount > 0) {
            this.lowestCount--;
            this.items[this.lowestCount] = element;
        } else {
            for (let i = this.count; i > 0; i--) {
                this.items[i] = this.items[i - 1];
            }
            this.count++;
            this.items[0] = element;
        }
    }

    addBack(element) {
        this.items[this.count] = element;
        this.count++;
    }

    removeFront() {
        if (this.isEmpty()) {
            return undefined;
        }
        const result = this.items[this.lowestCount];
        delete this.items[this.lowestCount];
        this.lowestCount++;
        return result;
    }

    removeBack() {
        if (this.isEmpty()) {
            return undefined;
        }
        this.count--;
        const result = this.items[this.count];
        delete this.items[this.count];
        return result;
    }

    peekFront() {
        if (this.isEmpty()) {
            return undefined;
        }
        return this.items[this.lowestCount];
    }

    peekBack() {
        if (this.isEmpty()) {
            return undefined;
        }
        return this.items[this.count - 1];
    }

    isEmpty() {
        return this.count - this.lowestCount === 0;
    }

    size() {
        return this.count - this.lowestCount;
    }

    clear() {
        this.items = {};
        this.count = 0;
        this.lowestCount = 0;
    }

    toString() {
        if (this.isEmpty()) {
            return "";
        }
        let objString = `${this.items[this.lowestCount]}`;
        for (let i = this.lowestCount + 1; i < this.count; i++) {
            objString = `${objString},${this.items[i]}`;
        }
        return objString;
    }
}
